import { useShallow } from 'zustand/shallow';

import { useTimeWindowUpdateStore } from '@/store/time-window-update.store.ts';
import Select, { Option } from '@ingka/select';
import { translate } from '@repo/phrase';
import type { ModifyReasonCodesData } from '@repo/types/store-details';

interface ModifyReasonSelectProps {
    reasonCodes: ModifyReasonCodesData[];
}

export const ModifyReasonSelect = ({ reasonCodes }: ModifyReasonSelectProps) => {
    const { selectedReasonCode, setSelectedReasonCode } = useTimeWindowUpdateStore(
        useShallow((state) => ({
            selectedReasonCode: state.selectedReasonCode,
            setSelectedReasonCode: state.setSelectedReasonCode,
        }))
    );

    return (
        <Select
            id="modify-reason-select"
            data-testid="modify-reason-select"
            label={translate('asset_time_window_change_reason_label')}
            value={selectedReasonCode}
            onChange={(e) => {
                setSelectedReasonCode(e.target.value);
            }}
        >
            {reasonCodes.map((reason) => {
                return <Option key={reason} value={reason} name={translate(`asset_modify_reason_${reason}`)} />;
            })}
        </Select>
    );
};
